import { Component, output, viewChild } from '@angular/core';
import { Popover } from '@ntv360/component-pantry';
import { PLAYLIST_ACTIONS_MENU } from '../constants';

@Component({
    selector: 'app-playlist-actions',
    imports: [Popover],
    templateUrl: './actions.component.html',
    styleUrl: './actions.component.scss',
})
export class ActionsComponent {
    protected readonly playlistActions = PLAYLIST_ACTIONS_MENU;

    public onShow = output<void>();
    public onHide = output<void>();

    protected popoverRef = viewChild.required(Popover);

    public toggle(event: Event): void {
        this.popoverRef().toggle(event);
    }
}
